import {
    IAtendimentoRepasseCaso,
    IListarCartorio,
    IListarModalidade,
    IListaVinculacao,
    ITipoContrato,
} from "../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarDadosRepasseService(ID_CASO: number) {
    return Service(
        Axios.get<IAtendimentoRepasseCaso>(
            `/repasse/casorepassedados/getcasorepassedadosporcaso?ID_CASO=${ID_CASO}`
        )
    );
}

export async function AtualizaDadosRepasseService(
    formData: IAtendimentoRepasseCaso
) {
    return Service(
        Axios.put<IAtendimentoRepasseCaso>(
            `/repasse/casorepassedados/atualizacasorepassedados`,
            formData
        )
    );
}

export async function ListarVinculacaoService() {
    return Service(
        Axios.get<Array<IListaVinculacao>>(
            `/repasse/casorepassedados/listaagenciavinculacao`
        )
    );
}

export async function ListarModalidadeService() {
    return Service(
        Axios.get<Array<IListarModalidade>>(
            `/repasse/casorepassedados/listatipomodalidade`
        )
    );
}

export async function ListarCatorioService() {
    return Service(
        Axios.get<Array<IListarCartorio>>(
            `/repasse/casorepassedados/listacartorio`
        )
    );
}

export async function ListarTiposContratoRepasseService() {
    return Service(
        Axios.get<Array<ITipoContrato>>(
            `/repasse/casorepassedados/listartiposcontratorepasse`
        )
    );
}
